import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import CarrierPaperFreeMonitoringReport
  from '../../component/CarrierPaperFreeMonitoringReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
  getTotalColumns,
} from '../redux/selectors/CarrierPaperFreeMonitoringDetailsSelectors';

export class CarrierPaperFreeMonitoringDetailsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPaperFreeAppButton: true,
    };
  }

  render() {
    return (
      <CarrierPaperFreeMonitoringReport
        reportId={ReportDefinitions.PAPER_FREE_MONITORING_CARRIER_903_DETAILS.id}
        columns={this.props.columns}
        totalColumns={this.props.totalColumns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        showPaperFreeAppButton={this.state.showPaperFreeAppButton}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
    totalColumns: getTotalColumns(state),
  };
}

CarrierPaperFreeMonitoringDetailsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
  totalColumns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(CarrierPaperFreeMonitoringDetailsContainer);
